import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@rsos/base-components';
import { useLazyAcceptRcsConversationQuery } from '@rsos/reduxDataStore/src/features/rcs/rcsApi';
import { useSelectedRcsConversation } from '@rsos/reduxDataStore/src/features/rcs/rcsSelectors';
import { selectUserOrgByApp } from '@rsos/sinatra';
import { RootState } from '../../../../app';
import {
  trackAcceptRCSChat,
  trackAcceptRCSChatResponse,
} from '../rcsTrackings';
import styles from './RcsChat.module.scss';

const RcsAcceptDeclineChat = () => {
  const selectedCallerID = useSelector(
    (state: RootState) => state.emergencyCalls.selectedCallerID,
  );

  const orgName = useSelector(
    (state: RootState) =>
      selectUserOrgByApp(
        state.sinatra,
        state.sinatra.user.currentRole?.application || '',
      )?.name,
  );

  const rcsConversation = useSelectedRcsConversation(selectedCallerID);
  const conversationId = useMemo(
    () => rcsConversation?.data?.conversation_id,
    [rcsConversation],
  );
  const sessionId = useMemo(
    () => rcsConversation?.data?.session_id,
    [rcsConversation],
  );

  const [triggerAcceptRcsConversation] = useLazyAcceptRcsConversationQuery();

  const handleAcceptConversation = useCallback(() => {
    trackAcceptRCSChat({
      conversationId,
      sessionId,
    });
    triggerAcceptRcsConversation({
      callerID: selectedCallerID,
      orgName,
    })
      .unwrap()
      .then(() => {
        trackAcceptRCSChatResponse({
          success: true,
          conversationId,
          sessionId,
        });
      })
      .catch(() => {
        trackAcceptRCSChatResponse({
          success: false,
          conversationId,
          sessionId,
        });
      });
  }, [
    selectedCallerID,
    orgName,
    triggerAcceptRcsConversation,
    conversationId,
    sessionId,
  ]);

  return (
    <div className={styles.acceptDeclineContainer}>
      <div className={styles.acceptDeclineInnerBox}>
        <Button
          btnType="primary"
          isLoadingProp={false}
          noMargin
          onClick={handleAcceptConversation}
          size="med"
          grow
        >
          Accept
        </Button>
      </div>
    </div>
  );
};

export default RcsAcceptDeclineChat;
